// extracted by mini-css-extract-plugin
export default {"receipt":"Receipt_receipt__5O8bo"};